// extracted by mini-css-extract-plugin
export default {"banner":"HM","banner_wrapper":"IM","text":"JM","new_at":"KM","rounded_arrow":"LM","image":"MM","video":"NM"};
    if(module.hot) {
      // 1714422956777
      var cssReload = require("../../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  